import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';
import FirstIcon from '@material-ui/icons/FirstPage';
import PreviousIcon from '@material-ui/icons/ChevronLeft';
import NextIcon from '@material-ui/icons/ChevronRight';
import LastIcon from '@material-ui/icons/LastPage';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'pagination';

class Paginator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(page) {
    const { onChange } = this.props;

    this.setState({ currentPage: page }, () =>
      onChange(this.state.currentPage)
    );
  }

  render() {
    const {
      classes,
      itemsCount,
      itemsPerPage,
      rootClassName,
      currentPageOverride,
    } = this.props;

    // The current page can either be handled by the paginator itself, or
    // outside the component using the currentPageOverride prop.
    const currentPage = currentPageOverride
      ? currentPageOverride
      : this.state.currentPage;

    const pages = [];
    for (let i = 1; i <= Math.ceil(itemsCount / itemsPerPage); i++) {
      pages.push(i);
    }
    const lastPage = pages.length;

    return (
      <div className={`${classes.root} ${rootClassName}`}>
        <Button
          onClick={() => this.handleChange(1)}
          disabled={currentPage <= 1}
          className={`${classes.button} ${classes.buttonFirst}`}
          mini={true}
        >
          <FirstIcon className={classes.icon} />
          <VisuallyHidden body={getString(stringsComponent, 'FIRST_LABEL')} />
        </Button>
        <Button
          onClick={() => this.handleChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className={classes.button}
          mini={true}
        >
          <PreviousIcon className={classes.icon} />
          <VisuallyHidden
            body={getString(stringsComponent, 'PREVIOUS_LABEL')}
          />
        </Button>
        <Typography className={classes.pageLabel}>
          {getString(stringsComponent, 'PAGE_LABEL')} {currentPage}/{lastPage}
        </Typography>
        <Button
          onClick={() => this.handleChange(currentPage + 1)}
          disabled={currentPage >= lastPage}
          className={classes.button}
          mini={true}
        >
          <NextIcon className={classes.icon} />
          <VisuallyHidden body={getString(stringsComponent, 'NEXT_LABEL')} />
        </Button>
        <Button
          onClick={() => this.handleChange(lastPage)}
          disabled={currentPage >= lastPage}
          className={`${classes.button} ${classes.buttonLast}`}
          mini={true}
        >
          <LastIcon className={classes.icon} />
          <VisuallyHidden body={getString(stringsComponent, 'LAST_LABEL')} />
        </Button>
      </div>
    );
  }
}

Paginator.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  itemsCount: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number,
  rootClassName: PropTypes.object,
  currentPageOverride: PropTypes.number,
};

Paginator.defaultProps = {
  itemsPerPage: 10,
  rootClassName: null,
  currentPageOverride: null,
};

export default withStyles(styles)(Paginator);
